var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import Autocomplete from "@mui/joy/Autocomplete";
import { useGetModuleListQuery } from "@/store/api";
import "./relate.css";
import Input from "@mui/joy/Input";
/** <b>Composant d'affichage en mode édition d'un champ de type relate</b>*/
export default function RelateFieldEdit(_a) {
    var fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate, fieldMetadata = _a.fieldMetadata, isOnStudio = _a.isOnStudio;
    var idFieldName = fieldMetadata.id_name;
    // Get the default value from the record based on the idFieldName
    var defaultValue = useMemo(function () {
        if (!record)
            return null;
        var recordId = record[idFieldName];
        var recordName = record[fieldName];
        if (recordId && recordName) {
            return { id: recordId, name: recordName };
        }
        return null;
    }, [record, fieldName, idFieldName]);
    var _b = useState(defaultValue), selectedOption = _b[0], setSelectedOption = _b[1];
    useEffect(function () {
        if (defaultValue) {
            setSelectedOption(defaultValue);
        }
    }, [defaultValue]);
    var moduleList = useGetModuleListQuery({
        table: fieldMetadata.module,
        params: {},
    }).data;
    var options = useMemo(function () {
        return ((moduleList === null || moduleList === void 0 ? void 0 : moduleList.data.records.map(function (element) { return ({
            id: element.id,
            name: element.name,
        }); })) || []);
    }, [moduleList]);
    var handleOnChange = function (event, newValue) {
        if (newValue) {
            setSelectedOption(newValue);
            record[fieldName] = newValue.name;
            record[idFieldName] = newValue.id;
            onUpdate && onUpdate(record);
        }
        else {
            record[idFieldName] = "";
            onUpdate && onUpdate(record);
        }
    };
    var isOptionEqualToValue = function (option, value) {
        return option.id === value.id;
    };
    return (_jsx("span", __assign({ className: "flex items-center cursor-pointer" }, { children: isOnStudio ? (_jsx(Input, { type: "text", className: "w-full" })) : (_jsx(Autocomplete, { onChange: handleOnChange, value: selectedOption, placeholder: "Search ...", options: options, getOptionLabel: function (option) { return option.name; }, sx: { width: 300 }, defaultValue: defaultValue, disableClearable: false, loadingText: "loading ...", isOptionEqualToValue: isOptionEqualToValue })) })));
}
